import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-split-transaction-page',
  templateUrl: './split-transaction-page.component.html',
  styleUrls: ['./split-transaction-page.component.scss']
})
export class SplitTransactionPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
